import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import CustomSelect from "../CustomSelect";
import "./moduliProtocollati.css";

const AddModuliProtocollato = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isAuthorized, setIsAuthorized] = useState(false);

  const [formData, setFormData] = useState({
    titoloModulo: "",
    oreModulo: "",
    modalitàErogazione: "",
    materialeAttrezzature: "",
    previsteDispense: "",
    proveFinali: "",
    descrizione: "",
  });

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (userRole !== "TRAINER") {
      toast.error("Accedi come docente per aggiungere i moduli protocollati!", {
        position: "top-center",
        autoClose: 3000,
        transition: Bounce,
      });

      setTimeout(() => {
        navigate("/login");
        localStorage.clear();
      }, 3000);
    } else {
      setIsAuthorized(true);
    }
  }, [navigate]);

  const valid = () => {
    const inputErrors = {};

    if (!formData.titoloModulo.trim()) {
      inputErrors.titoloModulo =
        "Il campo Titolo del modulo non può essere vuoto!";
    }

    const oreVal = Number(formData.oreModulo);
    if (formData.oreModulo === "" || isNaN(oreVal)) {
      inputErrors.oreModulo = "Il campo Ore del modulo non può essere vuoto!";
    } else if (oreVal > 60) {
      inputErrors.oreModulo = "Le ore del modulo non possono superare 60.";
    }

    if (!formData.modalitàErogazione) {
      inputErrors.modalitàErogazione =
        "Il campo Modalità di erogazione non può essere vuoto!";
    }

    if (!formData.materialeAttrezzature.trim()) {
      inputErrors.materialeAttrezzature =
        "Il campo Materiale e attrezzature non può essere vuoto!";
    }

    if (!formData.previsteDispense) {
      inputErrors.previsteDispense =
        "Il campo Dispense previste non può essere vuoto!";
    }

    if (!formData.proveFinali) {
      inputErrors.proveFinali = "Il campo Prove finali non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target || {};
    setFormData((prev) => ({
      ...prev,
      [name]: name === "oreModulo" ? value : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const handleSubmit = async () => {
    if (!valid()) return;

    setLoading(true);
    try {
      await api.post("/moduli-protocollati", {
        ...formData,
        oreModulo: Number(formData.oreModulo),
      });
      toast.success("Modulo protocollato creato con successo!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      navigate("/moduli-protocollati");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="add-moduli-modern-bg">
      {loading && (
        <div className="add-moduli-modern-overlay">
          <div className="add-moduli-modern-spinner"></div>
        </div>
      )}
      <div className="add-moduli-modern-card">
        <div className="add-moduli-modern-header">
          <button
            onClick={() => navigate("/moduli-protocollati")}
            className="add-moduli-modern-back"
            title="Torna indietro"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2>
            <i className="fa-solid fa-file-circle-plus"></i>
            Aggiungi Modulo Protocollato
          </h2>
        </div>
        <form
          className="add-moduli-modern-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="add-moduli-modern-fields">
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-file-alt"></i>
                Titolo del modulo
              </label>
              <input
                type="text"
                name="titoloModulo"
                placeholder="Inserisci il titolo del modulo"
                value={formData.titoloModulo}
                onChange={handleChange}
                required
                className={errors.titoloModulo ? "error" : ""}
              />
              {errors.titoloModulo && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.titoloModulo}
                </span>
              )}
            </div>
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-clock"></i>
                Ore del modulo (max 60)
              </label>
              <input
                type="number"
                name="oreModulo"
                placeholder="Inserisci le ore del modulo"
                value={formData.oreModulo}
                min="0"
                onChange={handleChange}
                required
                className={errors.oreModulo ? "error" : ""}
              />
              {errors.oreModulo && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.oreModulo}
                </span>
              )}
            </div>

            {/* Modalità di erogazione */}
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-chalkboard-teacher"></i>
                Modalità di erogazione
              </label>
              <CustomSelect
                options={[
                  { value: "FAD", label: "Fad" },
                  { value: "PRESENZA", label: "Presenza" },
                  { value: "ENTRAMBI", label: "Entrambi" },
                ]}
                value={
                  formData.modalitàErogazione
                    ? {
                        value: formData.modalitàErogazione,
                        label:
                          {
                            FAD: "Fad",
                            PRESENZA: "Presenza",
                            ENTRAMBI: "Entrambi",
                          }[formData.modalitàErogazione] || "",
                      }
                    : null
                }
                onChange={(selected) =>
                  handleChange({
                    target: {
                      name: "modalitàErogazione",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                placeholder="Seleziona modalità di erogazione"
              />
              {errors.modalitàErogazione && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.modalitàErogazione}
                </span>
              )}
            </div>

            {/* Materiale e attrezzature */}
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-tools"></i>
                Materiale e attrezzature
              </label>
              <input
                type="text"
                name="materialeAttrezzature"
                placeholder="Inserisci materiale e attrezzature"
                value={formData.materialeAttrezzature}
                onChange={handleChange}
                className={errors.materialeAttrezzature ? "error" : ""}
              />
              {errors.materialeAttrezzature && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.materialeAttrezzature}
                </span>
              )}
            </div>

            {/* Dispense previste */}
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-book"></i>
                Dispense previste
              </label>
              <CustomSelect
                options={[
                  { value: "NO", label: "No" },
                  { value: "SI_LIBRO", label: "Si, libro" },
                  { value: "SI_ELABORATI", label: "Si, elaborati" },
                ]}
                value={
                  formData.previsteDispense
                    ? {
                        value: formData.previsteDispense,
                        label:
                          {
                            NO: "No",
                            SI_LIBRO: "Si, libro",
                            SI_ELABORATI: "Si, elaborati",
                          }[formData.previsteDispense] || "",
                      }
                    : null
                }
                onChange={(selected) =>
                  handleChange({
                    target: {
                      name: "previsteDispense",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                placeholder="Seleziona dispense previste"
              />
              {errors.previsteDispense && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.previsteDispense}
                </span>
              )}
            </div>

            {/* Prove Finali */}
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-graduation-cap"></i>
                Prove Finali
              </label>
              <CustomSelect
                options={[
                  { value: "NO", label: "No" },
                  { value: "SI_ORALE", label: "Si, orale" },
                  { value: "SI_SCRITTA", label: "Si, scritta" },
                ]}
                value={
                  formData.proveFinali
                    ? {
                        value: formData.proveFinali,
                        label:
                          {
                            NO: "No",
                            SI_ORALE: "Si, orale",
                            SI_SCRITTA: "Si, scritta",
                          }[formData.proveFinali] || "",
                      }
                    : null
                }
                onChange={(selected) =>
                  handleChange({
                    target: {
                      name: "proveFinali",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                placeholder="Seleziona prove finali"
              />
              {errors.proveFinali && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.proveFinali}
                </span>
              )}
            </div>

            {/* Descrizione */}
            <div className="add-moduli-modern-field">
              <label className="add-moduli-modern-label">
                <i className="fa-solid fa-align-left"></i>
                Descrizione
              </label>
              <textarea
                name="descrizione"
                placeholder="Inserisci la descrizione del modulo"
                value={formData.descrizione}
                onChange={handleChange}
                rows="4"
                className={errors.descrizione ? "error" : ""}
              />
              {errors.descrizione && (
                <span className="add-moduli-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.descrizione}
                </span>
              )}
            </div>
          </div>

          <div className="add-moduli-modern-actions">
            <button
              type="button"
              className="add-moduli-modern-cancel"
              onClick={() => navigate("/moduli-protocollati")}
            >
              <i className="fa-solid fa-times"></i>
              Annulla
            </button>
            <button type="submit" className="add-moduli-modern-save">
              <i className="fa-solid fa-plus"></i>
              Aggiungi
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddModuliProtocollato;
